import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Button,
  Typography
} from '@mui/material';

const AIMemoryForm = ({ initialData, onSubmit, isEditMode = false, agents = [] }) => {
  const [formData, setFormData] = React.useState(initialData || {
    agentId: '',
    taskType: '',
    content: '',
    metadata: {
      relevance: 0.8,
      quality: 0.8,
      context: {}
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {isEditMode ? 'Edit Memory Entry' : 'Create New Memory Entry'}
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>Agent</InputLabel>
              <Select
                value={formData.agentId}
                onChange={(e) => handleChange('agentId', e.target.value)}
                label="Agent"
              >
                {agents.map((agent) => (
                  <MenuItem key={agent._id} value={agent._id}>
                    {agent.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>Task Type</InputLabel>
              <Select
                value={formData.taskType}
                onChange={(e) => handleChange('taskType', e.target.value)}
                label="Task Type"
              >
                <MenuItem value="blog_writer">Blog Writer</MenuItem>
                <MenuItem value="service_updater">Service Updater</MenuItem>
                <MenuItem value="forum_manager">Forum Manager</MenuItem>
                <MenuItem value="newsletter_generator">Newsletter Generator</MenuItem>
                <MenuItem value="social_media_publisher">Social Media Publisher</MenuItem>
                <MenuItem value="analytics_reporter">Analytics Reporter</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={6}
              label="Content"
              value={formData.content}
              onChange={(e) => handleChange('content', e.target.value)}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="number"
              label="Relevance Score"
              value={formData.metadata.relevance}
              onChange={(e) => handleChange('metadata.relevance', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 1, step: 0.1 }}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="number"
              label="Quality Score"
              value={formData.metadata.quality}
              onChange={(e) => handleChange('metadata.quality', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 1, step: 0.1 }}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Context (JSON)"
              value={JSON.stringify(formData.metadata.context, null, 2)}
              onChange={(e) => {
                try {
                  const parsed = JSON.parse(e.target.value);
                  handleChange('metadata.context', parsed);
                } catch (error) {
                  // Handle invalid JSON
                }
              }}
              helperText="Enter memory context data in JSON format"
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button type="submit" variant="contained" color="primary">
            {isEditMode ? 'Update Memory' : 'Create Memory'}
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default AIMemoryForm; 